<template>
<div class="container-fluid">

	<form-toolbar></form-toolbar>

</div>
</template>
<script type="text/javascript">

import FormToolbar from "@/pages/forms/FormToolbar"

export default {
	name: "FormsList",
	components: {
		FormToolbar,
	},
	mixins: [],
	data() {
		return {
			tab: 'list',

			tabs: [
				{
					label: "Templates",
					path: "/forms/templates",
					icon: "fa-clipboard-check"
				},
				{
					label: "List",
					path: "/forms/list",
					icon: "fa-list"
				},
				{
					label: "Analytics",
					path: "/forms/analytics",
					icon: "fa-chart-line"
				}
			]
		}
	},
	computed: {

	},
	methods: {

	},
	created() {
		if ("tab" in this.$route.params)
			this.tab = this.$route.params.tab

		if ('template_slug' in this.$route.params)
			this.templateSlug = this.$route.params.template_slug
	}
}
</script>